import {Injectable} from '@angular/core';
import {AngularFirestore} from '@angular/fire/compat/firestore';
import {MatTableDataSource} from '@angular/material/table';
import {GoogleChartInterface} from 'ng2-google-charts';
import {Ordered} from '../models/ordered';
import {Waiting} from '../models/waiting';
import {map, Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class DashboardService {

  public originPieCharts: GoogleChartInterface[] = [];
  public allOriginPieCharts: GoogleChartInterface[] = [];
  public allValuesPieCharts: GoogleChartInterface[] = [];
  public allCategoriesPieCharts: GoogleChartInterface[] = [];

  public arrayOrders: Ordered[] = [];

  public waitingDataSource: MatTableDataSource<any>
  public waitingDisplayedColumns: string[] = [ 'icon', 'member', 'status' ];

  public refundDataSource: MatTableDataSource<any>
  public refundDisplayedColumns: string[] = [ 'icon', 'member', 'date' ];


  constructor (
    private db: AngularFirestore) {
  }

  async getOrigins (product_id): Promise<any> {

    return this.db.collection<Ordered>('sbccv_orders', ref => ref
      .where('product_id', '==', product_id)
      .orderBy('date', 'asc')).snapshotChanges()
      .subscribe((result) => {

        let adminCount: number = 0;
        let androidCount: number = 0;
        let iosCount: number = 0;
        let gn1Count: number = 0;

        this.originPieCharts = []

        result.forEach((item) => {
          if (item.payload.doc.data().returnCode == '00') {

            switch (item.payload.doc.data().origin) {
              case "iOS":
                iosCount += 1
                break;
              case "Android":
                androidCount += 1
                break;
              case "Admin":
                adminCount += 1
                break;
              case "GN1":
                gn1Count += 1
                break;
            }

          }

        })

        /////////////////////

        /*
        console.log("iosCount" + iosCount)
        console.log("androidCount" + androidCount)
        console.log("gn1Count" + gn1Count)
        console.log("adminCount" + adminCount)
        */

        let _originPieChart = {
          chartType: 'PieChart',
          dataTable: [
            [ '', '' ],
            [ 'iOs', iosCount ],
            [ 'Android', androidCount ],
            [ 'GN1', gn1Count ],
            [ 'Admin', adminCount ]
          ],
          options: {
            // 'title': '',
            'width': 800,
            'height': 400,
            'is3D': true
          },
        };

        this.originPieCharts.push(_originPieChart)

      })
    console.log(this.originPieCharts)


  }

  async getWaitingList (product_id): Promise<any> {

    return this.db.collection<any>('sbccv_waiting_list', ref => ref
      .where('product.id', '==', product_id)
      .where('allowed', '==', true)
      .where('waiting', '==', true)
      .orderBy('product.data.name', 'asc')
      .orderBy('member.data.name', 'asc')).snapshotChanges()
      .subscribe((result) => {
        let array: Waiting[] = []
        result.forEach((item) => {
          let entity = new Waiting()
          entity.id = item.payload.doc.id;
          entity.product_id = item.payload.doc.data().product.id;
          entity.product_name = item.payload.doc.data().product.data.name;
          entity.member_id = item.payload.doc.data().member.id;
          entity.member_name = item.payload.doc.data().member.data.name;
          entity.member_email = item.payload.doc.data().member.data.email;
          entity.waiting = item.payload.doc.data().waiting;
          entity.allowed = item.payload.doc.data().allowed;
          array.push(entity);
        })
        this.waitingDataSource = new MatTableDataSource(array);
      })

  }

  async getRefundList (product_id): Promise<any> {

    return this.db.collection<any>('sbccv_orders', ref => ref
      .where('product_id', '==', product_id)
      .where('returnCode', '==', 'refundrequest')
      .orderBy('refund.dateRequest', 'desc')).snapshotChanges()
      .subscribe((result) => {
        let array: Ordered[] = []
        result.forEach((item) => {
          array.push(this.createOrderObj(item));
        })
        this.refundDataSource = new MatTableDataSource(array);
      })

  }

  async getAllOrigins (): Promise<any> {

    return this.db.collection<Ordered>('sbccv_orders', ref => ref
      .orderBy('date', 'asc')).snapshotChanges()
      .subscribe((result) => {

        let adminCount: number = 0;
        let androidCount: number = 0;
        let iosCount: number = 0;
        let gn1Count: number = 0;

        this.allOriginPieCharts = []

        result.forEach((item) => {
          if (item.payload.doc.data().returnCode == '00') {

            switch (item.payload.doc.data().origin) {
              case "iOS":
                iosCount += 1
                break;
              case "Android":
                androidCount += 1
                break;
              case "Admin":
                adminCount += 1
                break;
              case "GN1":
                gn1Count += 1
                break;
            }

          }

        })

        /////////////////////

        let _allOriginPieChart = {
          chartType: 'PieChart',
          dataTable: [
            [ '', '' ],
            [ 'iOs', iosCount ],
            [ 'Android', androidCount ],
            [ 'GN1', gn1Count ],
            [ 'Admin', adminCount ]
          ],
          options: {
            // 'title': '',
            'legend': 'left',
            // 'width': 800,
            'height': 300,
            //'is3D': true
            'chartArea': {left: 20, top: 20, width: "100%", height: 250}
          },
        };

        this.allOriginPieCharts.push(_allOriginPieChart)

      })

  }

  async getAllValues (): Promise<any> {

    return this.db.collection<Ordered>('sbccv_orders', ref => ref
      .orderBy('product_name', 'asc')).snapshotChanges()
      .subscribe((result) => {


        this.allValuesPieCharts = []

        let dataTables: any[] = []
        dataTables.push([ '', '' ])

        let currentProductId: string = "";
        let currentProductName: string = "";
        let productValue: number;

        result.forEach((item) => {

          if (item.payload.doc.data().returnCode == '00'
            && item.payload.doc.data().product_id != 'l5HoYFLNMtvtLVaNN3YZ') //anuidade
          {

            if (item.payload.doc.data().product_id == currentProductId) {
              productValue += item.payload.doc.data().value
            } else {

              dataTables.push([ item.payload.doc.data().product_name, productValue ? productValue : '' ])
              currentProductId = item.payload.doc.data().product_id
              productValue = item.payload.doc.data().value
            }



          }

        })

        /////////////////////

        let _allValuePieChart = {
          chartType: 'PieChart',
          dataTable: dataTables,
          options: {
            // 'title': '',
            'legend': 'left',

            'height': 300,
            'chartArea': {left: 20, top: 20, width: "100%", height: 250}
            //  'is3D': true
          },
        };

        this.allValuesPieCharts.push(_allValuePieChart)

      })


  }


  async getAllCategories (): Promise<any> {

    return this.db.collection<Ordered>('sbccv_orders', ref => ref
      .orderBy('category_name', 'asc')).snapshotChanges()
      .subscribe((result) => {


        this.allCategoriesPieCharts = []

        let dataTables: any[] = []
        dataTables.push([ '', '' ])

        let currentCategoryId: string = "";
        let productValue: number;

        result.forEach((item) => {

          if (item.payload.doc.data().returnCode == '00'
            && item.payload.doc.data().product_id != 'l5HoYFLNMtvtLVaNN3YZ') //anuidade
          {

            if (item.payload.doc.data().category_id == currentCategoryId) {
              productValue += item.payload.doc.data().value
            } else {

              dataTables.push([ item.payload.doc.data().category_name, productValue ? productValue : '' ])
              currentCategoryId = item.payload.doc.data().category_id
              productValue = item.payload.doc.data().value
            }

          }

        })

        /////////////////////

        let _allCategoryPieChart = {
          chartType: 'PieChart',
          dataTable: dataTables,
          options: {
            // 'title': '',
            'legend': 'left',

            'height': 300,
            'chartArea': {left: 20, top: 20, width: "100%", height: 250}
            //  'is3D': true
          },
        };

        this.allCategoriesPieCharts.push(_allCategoryPieChart)

      })


  }


  createOrderObj (item) {

    let order = new Ordered();
    order.id = item.payload.doc.id;
    order.date = item.payload.doc.data().date;
    order.product_id = item.payload.doc.data().product_id;
    order.product_name = item.payload.doc.data().product_name;
    order.member_id = item.payload.doc.data().member_id;
    order.member_name = item.payload.doc.data().member_name;
    order.member_cpf = item.payload.doc.data().member_cpf;
    order.member_cellPhone = item.payload.doc.data().member_cellPhone;
    order.member_email = item.payload.doc.data().member_email;
    order.member_debit = item.payload.doc.data().member_debit;
    order.category_id = item.payload.doc.data().category_id;
    order.category_name = item.payload.doc.data().category_name;
    order.value = item.payload.doc.data().value;
    order.payAsOverdue = item.payload.doc.data().payAsOverdue;
    order.until_date = item.payload.doc.data().until_date;
    order.lot_id = item.payload.doc.data().id;
    order.payment_date = item.payload.doc.data().payment_date;
    order.payment_type = item.payload.doc.data().payment_type;
    order.total = item.payload.doc.data().total;
    order.member_debit = item.payload.doc.data().member_debit;

    if (item.payload.doc.data().discount)
      order.discount = item.payload.doc.data().discount;
    else
      order.discount = 0.00;

    order.card_brand = item.payload.doc.data().card_brand;
    order.card_number = item.payload.doc.data().card_number;
    order.card_installments = item.payload.doc.data().card_installments;
    order.card_softdescriptor = item.payload.doc.data().card_softdescriptor;
    order.card_holder = item.payload.doc.data().card_holder;
    order.card_expirationDate = item.payload.doc.data().card_expirationDate;

    order.billet_name = item.payload.doc.data().billet_name;
    order.billet_identity = item.payload.doc.data().billet_identity;
    order.billet_street = item.payload.doc.data().billet_street;
    order.billet_number = item.payload.doc.data().billet_number;
    order.billet_complement = item.payload.doc.data().billet_complement;
    order.billet_zipCode = item.payload.doc.data().billet_zipCode;
    order.billet_district = item.payload.doc.data().billet_district;
    order.billet_city = item.payload.doc.data().billet_city;
    order.billet_state = item.payload.doc.data().billet_state;
    order.billet_country = item.payload.doc.data().billet_country;

    order.type = item.payload.doc.data().type;
    order.paymentId = item.payload.doc.data().paymentId;
    order.Tid = item.payload.doc.data().Tid;
    order.returnCode = item.payload.doc.data().returnCode;

    order.refund = item.payload.doc.data().refund;

    order.proofOfSale = item.payload.doc.data().proofOfSale;
    order.authorizationCode = item.payload.doc.data().authorizationCode;

    order.cash_operator = item.payload.doc.data().cash_operator;
    order.origin = item.payload.doc.data().origin;

    return order;

  }

  // alterações feitas pelo usuário na área-retrrrita.
getMembersDataChanges(): Observable<any[]> {
  return this.db.collection<Ordered>('sbccv_members_changes', ref => 
    ref.orderBy('timestamp', 'desc')
    .limit(100)
  )
  .snapshotChanges()
  .pipe(
    map(actions => actions.map(a => {
      const data = a.payload.doc.data();
      const id = a.payload.doc.id;
      return { id, ...data };
    }))
  );
}

}
